import { wrapGqlRequest } from "@/services/graphqlEndPointCommonSetting/wrapGqlRequest";
export const doEmailSubscriber = (email) => {
    // const requestOptions = {
    //     method: 'POST',
    //     headers: {
    //         'Content-type': 'application/json'
    //     },
    // };
    // return fetch(`${vueAppMagenotApiUrl}/rest/V1/newsletterapi/subscriber/${email}`, requestOptions)

    const subscribeEmailToNewsletterMutation = `
    mutation {
        subscribeEmailToNewsletter(input: {email: "${email}"}) {
        status
        }
    }
    `;
    return wrapGqlRequest(subscribeEmailToNewsletterMutation, {}, "subscribeEmailToNewsletter");
};
